import { deleteCustomsOfficeOfTransitExitV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function deleteCustomsOfficeOfTransitExit(id: number): Promise<void> {
  await deleteCustomsOfficeOfTransitExitV2(id)
}
